import { makeStyles } from "@material-ui/core";

export default makeStyles((theme: any) => ({
  root: {
        height: "80vh",
      justifyContent: "center",

  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  toolbar: theme.mixins.toolbar,
  plane: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    height: "95vh",
    width: "100%"
  },
  avatar: {
    margin: theme.spacing(1)
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  formBrands: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column'
  },
  submit: {
      margin: theme.spacing(3, 0, 2),
      paddingTop: 15,
      paddingBottom: 15,
      fontSize: 16
  },
  submitBrands: {
    marginTop: 20,
    paddingTop: 15,
    paddingBottom: 15,
    fontSize: 16
},
}));